import {CircularProgress, LinearProgress} from "@mui/material";

export const LoadingSection = (props?: { linear?: boolean }) => {
    return <>{props?.linear ? <LinearProgress/> : <div
        style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <CircularProgress/>
    </div>}</>
}